import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import logo from './PayParkingLogo.png';
import { Route, Switch } from 'react-router-dom';
import { Home } from './modules/Home';
import { Confirmation } from './modules/Confirmation';
import { Failed } from './modules/Failed';
import { NoMatch } from './modules/NoMatch';
import { useEffect, useState } from 'react';
import { useThemeSelector } from './shared/contexts/ThemeContext';
import { useTranslation } from 'react-i18next';
import { Language } from '@mui/icons-material';
import { useLocation, useHistory } from 'react-router-dom';
import { ApplePayProvider } from './shared/contexts/ApplePayContext';
import { GooglePayProvider } from './shared/contexts/GooglePayContext';
import ManagePass from './modules/ManagePass';

function App() {
  const { selectedTheme } = useThemeSelector();
  const { t, i18n } = useTranslation<{}>();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const location = useLocation();
  const history = useHistory();

  const handleLanguageClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLanguageClose = (lang?: string) => {
    setAnchorEl(null);
    if (lang) {
      i18n.changeLanguage(lang);

      const params = new URLSearchParams(location.search);
      params.set('lng', lang);

      history.replace({
        pathname: location.pathname,
        search: params.toString(),
      });
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const currentLng = params.get('lng');

    if (!currentLng) {
      const defaultLng = i18n.language || 'en';
      params.set('lng', defaultLng);
      history.replace({
        pathname: location.pathname,
        search: params.toString(),
      });
    }
  }, [location.search]);

  return (
    <Stack width={'100%'} alignItems="center">
      <Stack
        width={'100%'}
        spacing={2}
        alignItems="center"
        padding={2}
        sx={{ maxWidth: 500 }}
      >
        <img
          onClick={() => history.push('/')}
          src={selectedTheme.logoUrl ?? logo}
          style={{
            marginTop: selectedTheme.logoUrl ? undefined : '-16px',
          }}
          alt="Logo"
          width="100%"
        />
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Typography variant="h4">{t('payparking')}</Typography>
          <IconButton onClick={handleLanguageClick}>
            <Language />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => handleLanguageClose()}
          >
            <MenuItem onClick={() => handleLanguageClose('en')}>
              {t('english')}
            </MenuItem>
            <MenuItem onClick={() => handleLanguageClose('es')}>
              {t('spanish')}
            </MenuItem>
            <MenuItem onClick={() => handleLanguageClose('mao')}>
              {t('maori')}
            </MenuItem>
            <MenuItem onClick={() => handleLanguageClose('ge')}>
              {t('german')}
            </MenuItem>
          </Menu>
        </Box>
        <Switch>
          <Route exact path="/">
            <GooglePayProvider>
              <ApplePayProvider>
                <Home />
              </ApplePayProvider>
            </GooglePayProvider>
          </Route>
          <Route exact path="/site/:qrCode">
            <GooglePayProvider>
              <ApplePayProvider>
                <Home />
              </ApplePayProvider>
            </GooglePayProvider>
          </Route>
          <Route exact path="/renew/:sessionCode">
            <GooglePayProvider>
              <ApplePayProvider>
                <Home />
              </ApplePayProvider>
            </GooglePayProvider>
          </Route>
          <Route exact path="/confirmation/:details">
            <Confirmation />
          </Route>
          <Route exact path="/manage-pass">
            <ManagePass />
          </Route>
          <Route exact path="/failed">
            <Failed />
          </Route>
          <Route path="*">
            <NoMatch />
          </Route>
        </Switch>
      </Stack>
    </Stack>
  );
}

export default App;
